<ng-container *transloco="let t; prefix: 'PremiseHazardType'">
  <div class="page-container">
    <div class="list-view-container" [hidden]="listHidden">
      <div class="control-container">
        <app-premise-hazard-type-list (PremiseHazardTypeClicked)="onPremiseHazardTypeSelected($event)"
          (AddNewPremiseHazardTypeClicked)="addNewPremiseHazardTypeClicked()"
          [changeSelectedPremiseHazardType]="changePremiseHazardTypeViewSubject"
          [premiseHazardTypeDeletedSubject]="premiseHazardTypeDeletedSubject"
          ></app-premise-hazard-type-list>
      </div>
    </div>
    <div class="item-view-container" [hidden]="!listHidden">
      <div class="control-container">
        @if (IsViewing) {
        <app-premise-hazard-type-view [PremiseHazardType]="SelectedPremiseHazardType" [CanEdit]="canEdit"
          [CanDelete]="canDelete" (backClicked)="showList()" (editClicked)="onEditClicked($event)"
          (deleteClicked)="openDeleteConfirmDialog()"
          (isSharedEvent)="setSharedHazardType($event)"></app-premise-hazard-type-view>
        }
        @if (IsEditing) {
        <app-premise-hazard-type-item (submittedEvent)="onSubmitEvent($event)" (cancelEvent)="onCancelEvent()"
          [SelectedPremiseHazardType]="SelectedPremiseHazardType"
          [ETag]="SelectedPremiseHazardTypeEtag"></app-premise-hazard-type-item>
        }
      </div>
    </div>
  </div>
</ng-container>